export default __webpack_public_path__ + "static/media/nupy-logo.9664004a.png";